import './form-referral.scss';

import { ReferralFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = ReferralFormSchema;
export function FormReferral() {
  const { control } = useFormContext<ReferralFormSchema>();
  return (
    <div id="FormReferral" className="referral">
      <InputControl<InputFormSchema>
        control={control}
        name="tenant"
        label="Tenant"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter tenant"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="referrer"
        label="Referrer"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter referrer"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="referee"
        label="Referee"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter referee"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="status"
        label="Status"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter status"
      />
    </div>
  );
}

export default FormReferral;